import React from 'react'

import TimerView from '../../../../core/gd-components/task-timer/timer'
import {EntityType} from '../../../../core/gd/const/item'

type Props = {
    task    : {
        id      : ID
        title   : string
    }

    entityType? : EntityType    // defaults to TASK; MEETING for a meeting timer

    isOpen  : boolean
}

type State = {
    over    : boolean
}

export default class TaskTrayTimer extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            over: false
        }
    }

    onMouseEnter = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        this.setState({
            over: true
        })
    }

    onMouseLeave = (e: React.MouseEvent) => {
        this.setState({
            over: false
        })
    }

    get entityType() {
        return this.props.entityType ?? EntityType.TASK
    }

    onCloseClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        gd.taskTimers.cancelTimer(this.props.task.id, ()=>{
            if (this.entityType === EntityType.TASK) gd.taskTray.remove(this.props.task.id)
        }, this.entityType)
    }

    onTaskClick = () => {
        if (this.entityType === EntityType.MEETING) {
            gd.meetingView.open(this.props.task.id)
            return
        }
        gd.taskView.open(this.props.task.id)
    }

    render() {
        const classes = Classes('task', {
            open: this.props.isOpen
        })

        return (
            <div className={classes} onClick={this.onTaskClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <TimerView className    = "tray-timer"
                           taskId       = {this.props.task.id}
                           entityType   = {this.entityType}
                           onClose      = {this.onCloseClick}
                           showCancel   = {false} // close by stop please
                />

                <div className="name">{this.props.task.title}</div>

                {this.state.over &&
                    <div className="i5-delete-circle-solid" onClick={this.onCloseClick}/>}
            </div>
        )
    }
}
